export enum PlanType {
  Alpha = 'alpha',
  Beta = 'beta',
}
